import request from "./request";
import config from "../configs";
import Axios from "axios";

export async function upload(file: File, key: string) {
    const response = await request.get("/minio/url", {
        params: {key}
    })
    const url = response.data.data
    await Axios.put(url, file, {
        headers: {
            'Content-Type': file.type
        }
    })
    return key
}

export function getUrl(key: string) {
    const keyPath = key?.replaceAll('#', '%23');
    return `${config.MINIO_HOST}${keyPath}`
}
